let bfcacheRestoreTime = -1;

const getBFCacheRestoreTime = () => bfcacheRestoreTime;

const onBFCacheRestore = (cb) => {
  window.addEventListener(
    'pageshow',
    (event) => {
      if (event.persisted) {
        bfcacheRestoreTime = event.timeStamp;
        cb(event);
      }
    },
    true,
  );
};

module.exports = {
  getBFCacheRestoreTime,
  onBFCacheRestore,
};
